import React from 'react'
import Layout from '../layout/Layout'
import { Card } from 'react-bootstrap'
// import DefenderTable from './graph/DefenderTable'
// import ThreatLevelIssues from './graph/ThreatLevelIssues'
// import ThreatLevelCard from './graph/ThreatLevelCard'
// import ProgressBarComponent from './graph/ProgressBarComponent'

function DefenderScan() {
  return (
   <Layout title={"DefenderScan"}>
        <div className="container-fluid" style={{ paddingTop: '80px', paddingLeft: '30px', paddingRight: '30px' }}>
          <Card className="text-center" style={{ 
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            border: 'none',
            borderRadius: '12px',
            padding: '60px 40px',
            color: 'white',
            boxShadow: '0 10px 30px rgba(0,0,0,0.15)'
          }}>
            <Card.Body>
              <div style={{ fontSize: '48px', marginBottom: '20px' }}>🛡️</div>
              <h2 style={{ fontWeight: '700', marginBottom: '20px' }}>Vulnerability Scanning</h2>
              <p style={{ fontSize: '18px', marginBottom: '30px', opacity: 0.95 }}>
                Run comprehensive vulnerability scans for your Web Applications and Cloud Resources on demand
              </p>
              <div style={{ 
                backgroundColor: 'rgba(255,255,255,0.2)', 
                padding: '20px', 
                borderRadius: '8px',
                marginBottom: '30px'
              }}>
                <p style={{ fontSize: '16px', marginBottom: '10px' }}>✓ Web Application Security Testing</p>
                <p style={{ fontSize: '16px', marginBottom: '10px' }}>✓ Cloud Infrastructure Vulnerability Assessment</p>
                <p style={{ fontSize: '16px', marginBottom: '0' }}>✓ On-Demand Scanning & Detailed Reports</p>
              </div>
              <button 
                className="btn btn-light btn-lg"
                style={{ 
                  fontWeight: '600',
                  padding: '12px 40px',
                  borderRadius: '8px',
                  boxShadow: '0 4px 15px rgba(0,0,0,0.2)'
                }}
                onClick={() => window.location.href = '/dashboard/pricing'}
              >
                Upgrade Your Plan
              </button>
            </Card.Body>
          </Card>
        </div>
        {/* Hidden components - ready for future use */}
        {/* <DefenderTable /> */}
        {/* <ThreatLevelIssues /> */}
        {/* <ThreatLevelCard /> */}
        {/* <ProgressBarComponent /> */}
   </Layout>
  )
}

export default DefenderScan
